module.exports = __webpack_public_path__ + "static/media/l28.21aed109.jpg";